<script setup lang="ts">
import { getStripePaymentStatus } from '@/api/api';
import { useBookingDataStore } from '@/stores/bookingData';
import { useBookingStepStore } from '@/stores/bookingStep';
import { useTextStore } from '@/stores/texts';
import { onMounted, ref, watch } from 'vue';
import { analytics } from '@/analytics';

const bookingData = useBookingDataStore();
const bookingStep = useBookingStepStore();
const textStore = useTextStore();

const status = ref<any>({});
const TEXT_couponFree = ref('Votre réservation est entièrement couverte — aucun paiement n’est nécessaire.');

onMounted(async () => {
  console.log('confirmation', bookingData.getData(), bookingStep.checkoutId);
  // A coupon fully covered the total: there is no Stripe session to poll — the
  // backend already confirmed the booking, so render the success copy directly.
  if (bookingStep.freeBooking) {
    TEXT_couponFree.value = (await textStore.getText('coupon_free_notice')) || TEXT_couponFree.value;
    return;
  }
  if (bookingStep.checkoutId !== '') {
    status.value = await getStripePaymentStatus(bookingStep.checkoutId);
    console.log("stripe status", status.value);
  }
  watch(() => bookingStep.checkoutId, async (curr) => {
    console.log('checkout id changed', curr);
    if (curr !== undefined) {
      status.value = await getStripePaymentStatus(bookingStep.checkoutId);
      console.log("stripe status 2", status.value);
    }
  })
})

function bookingSuccess() {
  console.log('bookingSuccess', status.value)
  return bookingStep.freeBooking || status.value?.data?.payment?.status == 'succeeded';
}

const emittedConfirmed = ref(false);
watch(() => bookingSuccess(), (ok) => {
  if (ok && !emittedConfirmed.value) {
    emittedConfirmed.value = true;
    // Keep the current confirmation visible, but never restore a completed
    // booking (including customer details and coupons) on the next visit.
    for (const key of ['booking_data', 'booking_step', 'booking_mode', 'booking_id']) {
      localStorage.removeItem(key);
    }
    // getStripePaymentStatus returns { checkout, payment } — no booking key, so
    // the imported_id isn't reachable here for the normal Stripe-paid flow.
    // bookingId is only populated in menu/invite flows; null otherwise. The
    // Stripe checkout session id (when present) rides along in meta so the
    // backend can join to the booking later.
    analytics.track('booking_confirmed', {
      bookingImportedId: bookingStep.bookingId || null,
      mode: String(bookingStep.getMode()).toLowerCase(),
      venue: bookingData.venue || null,
      ...(bookingStep.checkoutId ? { meta: { stripeSessionId: bookingStep.checkoutId } } : {}),
    });
    analytics.flush();
    analytics.markBooked(); // close this session so a later visit is a new one
  }
}, { immediate: true });


</script>

<template>
  <div class="bpa-front-tabs--panel-body __bpa-is-active eauget-booking-step-type" data-testid="step-confirmation-panel">
    <div class="bpa-front-default-card"><!---->
      <div class="bpa-front-dc--body"><!---->
        <div class="el-row">
          <div class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-24 el-col-lg-24 el-col-xl-24">
            <div v-if="bookingStep.freeBooking || Object.keys(status).length > 0" class="bpa-front-module-container bpa-front-module--service" data-testid="confirmation-status">
              <p v-if="bookingSuccess()">Merci pour votre réservation !</p>
              <p v-else>Nous n'avons pas encore pu valider votre paiement.</p>
              <p v-if="bookingStep.freeBooking" data-testid="coupon-free-notice">{{ TEXT_couponFree }}</p>
              <p>Vous recevrez bientôt un email de confirmation reprenant les informations de votre réservation.</p>
            </div>
            <div v-else>Confirmation de votre réservation en cours...</div>
          </div>
        </div>
      </div>
      <div class="bpa-fm--service__advance-options">
        <div class="bpa-sao--body"><!----> <!----></div>
        <div class="bpa-sao--footer"><button type="button"
            class="el-button bpa-front-btn bpa-front-btn--borderless bpa-front-btn__medium el-button--default"><!----><!----><span>Annuler</span></button>
          <button type="button"
            class="el-button bpa-front-btn bpa-front-btn__medium bpa-front-btn--primary el-button--default"><!----><!----><span>Continuer</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media only screen and (max-width: 576px) {

  .menu-summary,
  p {
    margin: 0px 15px !important;
  }
}
</style>
